const state = {
  currentBreadcrumb: [],
}

const getters = {
  currentBreadcrumb: (state) => state.currentBreadcrumb,
}

const actions = {}

const mutations = {
  SET_CURRENT_BREADCRUMB: (state, breadcumb) => {
    state.currentBreadcrumb = breadcumb
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
